// Format a date value (Date instance, numeric timestamp, or parseable string)
export function formatDisplayDate(value) {
  if (!value && value !== 0) return "";
  // If it's already a Date
  if (value instanceof Date) {
    return value.toLocaleDateString("en-US", { month: "long", day: "numeric", year: "numeric" });
  }
  // If it's a number or numeric string (seconds or ms)
  const asNumber = Number(value);
  if (!Number.isNaN(asNumber) && String(value).trim() !== "") {
    const dt = new Date(asNumber < 1e12 ? asNumber * 1000 : asNumber);
    if (!Number.isNaN(dt.getTime())) {
      return dt.toLocaleDateString("en-US", { month: "long", day: "numeric", year: "numeric" });
    }
  }
  // Try parsing as a date string
  const parsed = new Date(value);
  if (!Number.isNaN(parsed.getTime())) {
    return parsed.toLocaleDateString("en-US", { month: "long", day: "numeric", year: "numeric" });
  }
  // Fallback: return as-is
  return String(value);
}